/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots.common || ($protobuf.roots.common = new $protobuf.Root()))
.addJSON({
  proto: {
    options: {
      go_package: "./proto"
    },
    nested: {
      PubOrderPayBrowserRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          },
          quitUrl: {
            type: "string",
            id: 3
          }
        }
      },
      PubOrderPayBrowserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          payUrl: {
            type: "string",
            id: 3
          }
        }
      },
      PubOrderPayWxBrowserRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          },
          appId: {
            type: "string",
            id: 3
          }
        }
      },
      PubOrderPayWxBrowserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          paySign: {
            type: "string",
            id: 3
          },
          signType: {
            type: "string",
            id: 4
          },
          appId: {
            type: "string",
            id: 5
          },
          "package": {
            type: "string",
            id: 6
          },
          nonceStr: {
            type: "string",
            id: 7
          },
          timestamp: {
            type: "string",
            id: 8
          }
        }
      },
      PaymentType: {
        values: {
          Init: 0,
          WechatMiniProgram: 1,
          WechatPay: 2,
          AliPay: 3
        }
      }
    }
  }
});

export { $root as default };
